import styled from "styled-components";

import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";

interface FlightInfoContainerProps {
  isMultiPax: boolean;
}

const FlightInfoContainer = styled.div<FlightInfoContainerProps>`
  background-color: ${({ theme }) => theme.colors.journeySectionBackground};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusJourney};
  overflow: hidden;
  box-sizing: border-box;

  ${TertiaryHeader} {
    font-size: 24px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: flex;
    position: absolute;
    right: 0px;
    left: 0px;
    top: 0px;
    justify-content: center;
    height: 200px;
    padding: 0 16px;
  }
`;

export default FlightInfoContainer;
